<template>
  <div class="farm-item-box">
    <div
      @click="
        e => {
          handleShowClick(item, index, e);
        }
      "
      :class="[
        'item',
        {
          'is-active': item.show,
          'is-disabled': item.wholeDisable,
          'is-use':!item.isUse
        },
      ]"
      :key="index"
      v-for="(item, index) in dataList"
    >
      <div>
        <i
          class="el-icon-circle-check active"
          v-if="item.showIcon"
          @click.stop="handleIconClick($event, item)"
          :title = item.tip
        ></i>
        {{ item.name }}
      </div>
      <div
        v-if="item.tupuBtn"
        :class="[
          'button',
          {
            'is-disabled': getDisabled(item),
          },
        ]"
        @click.stop="handleTupuClick(item, index, getDisabled(item))"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    id: {
      type: Number,
      require: true,
    },
    page: {
      type: String,
    },
    plan: {
      type: Object,
    },
  },
  data() {
    return {
      flag: 0,
      activeItem: null,
    };
  },
  watch: {
    dataList: {
      handler(val) {
        this.$store.commit('WindFarm/SET_FARM_LIST', val);
      },
      deep: true,
      immediate: true,
    },
    turbineList(val) {
      this.dataList
        .filter(i =>
          ['集电线路设计', '道路设计', '发电量计算'].includes(i.name)
        )
        .forEach(i => {
          i.wholeDisable = val.length === 0;
        });
    },
    activeTupu: {
      handler(val) {
        this.dataList[0].tupuShow = val == 0 || val == 1;
      },
    },
    '$route.query.planId'() {
      this.handleShowClick(-1);
      this.expand();
      console.log(this.dataList);
    },
    immediate: true,
  },
  computed: {
    ...mapGetters('WindFarm', [
      'exclusiveList',
      'boosterList',
      'turbineList',
      'windfarmRoadList',
      'keyPointsList',
      'entrancePointList',
      'specificDragFlag',
      'specificEditFlag',
      'specificChangeFlag',
      'windfarmWireList',
      'powerTurbineList',
      'activeTupu',
      'wrgInfoForm',
      'towerList',
    ]),
    dataList() {
      let data = [
        // {
        //   name: '容量规划',
        //   show: false,
        //   tupuShow: true,
        //   routerName: 'resource-selection',
        //   // tupuBtn: true,
        //   fengsuUrl: '',
        //   fenggonglvUrl: '',
        //   wholeDisable: false
        // },

        {
          name: '风机排布',
          tip: '点击可隐藏/显示风机',
          show: false,
          tupuShow: true,
          resultBtn: true,
          routerName: 'deploy',
          tupuBtn: true,
          fengsuUrl: '',
          fenggonglvUrl: '',
          wholeDisable: false,
          showIcon: this.plan?.deployStatus == 1,
          isUse: true
        },
        {
          name: '测风塔选址',
          tip: '点击可隐藏/显示测风塔',
          show: false,
          tupuShow: true,
          routerName: 'tower',
          tupuBtn: true,
          fengsuUrl: '',
          fenggonglvUrl: '',
          wholeDisable: false,
          showIcon: this.plan?.towerStatus == 1,
          isUse: true
        },

        {
          name: '电量计算',
          show: false,
          tupuShow: true,
          tupuBtn: false,
          routerName: 'power',
          fengsuUrl: '',
          fenggonglvUrl: '',
          wholeDisable: false,
          showIcon: this.plan?.energyStatus == 1,
          isUse: this.plan?.deployStatus == 1
        },

        {
          name: '经济评价',
          show: false,
          tupuShow: true,
          tupuBtn: false,
          routerName: 'economic-evaluation',
          fengsuUrl: '',
          fenggonglvUrl: '',
          wholeDisable: false,
          showIcon: this.plan?.economicStatus == 1,
          isUse: this.plan?.deployStatus == 1
        }/*,
        {
          name: '三维预览',
          routerName: '3d',
        }*/
      ];
      return data;
    },
  },
  created() {
    this.$bus.$on('farmClick', this.handleShowClick);
    this.$bus.$on('getIconShow', this.getIconShow);
    this.$bus.$on('getCluster', this.getCluster);
  },
  mounted() {
    this.expand();
  },
  beforeDestroy() {
    this.$bus.$off('farmClick', this.handleShowClick);
    this.$bus.$off('getIconShow', this.getIconShow);
    this.$bus.$off('getCluster', this.getCluster);
  },
  methods: {
    getResultDisabled(_name) {
      const { name } = this.$route;

      if (_name === '机位排布' && name === 'deploy') {
        return true;
      }

      if (_name === '道路设计' && name === 'road') {
        return true;
      }

      return false;
    },
    getResultText(name) {
      if (name === '机位排布') {
        if (this.specificDragFlag) {
          return '取消';
        }
        return '结果调整';
      } else if (name === '道路') {
        if (this.specificEditFlag) {
          return '取消';
        }

        return '结果调整';
      } else if (name === '道路设计') {
        if (this.specificChangeFlag) {
          return '取消';
        }
        return '结果调整';
      } else {
        return '结果调整';
      }
    },
    getDisabled(item) {
      if (item.name === '机位排布') {
        return this.specificDragFlag;
      }

      if (item.name === '道路设计') {
        return this.specificEditFlag;
      }

      if (item.name === '集电线路设计') {
        return this.specificChangeFlag;
      }
    },
    expand() {
      const { name } = this.$route;
      this.dataList.forEach((item) => {
        item.show = false;
      });

      const myItem = this.dataList.find(i => i.routerName === name);
      if (myItem) {
        myItem.show = true;
      } else {
        // myItem.show = false;
      }
    },
    handleShowClick(item, index) {
      if(!item.isUse && (index == 2 || index == 3)){
        return;
      }
      if (item?.routerName === '3d') {
        this.$router.push({
          path: `/3d/preview/planning`,
          query: {
            planId: this.$route.query.planId,
            projectId: this.$route.query.projectId,
            projectName: this.$route.query.projectName,
            planName: this.$route.query.planName,
          },
        });
        return;
      }

      console.log('item', item);

      if (typeof item === 'number') {
        if (item === -1) {
          this.dataList.map(i => {
            i.show = false;
          });
        } else {
          index = item;
          item = this.dataList[item];
        }
      }

      if (item.wholeDisable) {
        return;
      }

      if (this.specificDragFlag) {
        this.$bus.$emit('resultClickFj', (res) => {
          this.flag = res;
        });

        if (!this.flag) {
          return;
        }
      }

      if (this.specificEditFlag) {
        this.$nextTick(() => {
          this.$bus.$emit('resultClickDl', false);
        });
      }

      if (this.specificChangeFlag) {
        return this.$message.warning('正在线路调整中...');
      }
      if (!item.show) {
        this.dataList.forEach((i, _index) => {
          if (index !== _index) {
            i.show = false;
          }
        });
      }
      item.show = !item.show;
      if (item.show) {
        this.activeItem = item;
        this.activeItem.id = this.id;
      } else {
        this.activeItem = null;
      }

      console.log(' this.activeItem', this.activeItem);

      this.$emit('showClick', this.activeItem);
    },
    handleSaveRoadClick(item) {
      if (item.wholeDisable) {
        return;
      }

      this.$bus.$emit('roadSaveClick');
    },
    handleResultClick(item, index) {
      if (this.getResultDisabled(item.name)) return;

      if (item.wholeDisable) return;
      //console.log(item, index);

      if (item.name === '机位排布') {
        if (!item.tupuShow) {
          this.handleTupuClick(item, index, this.getDisabled(item));
        }

        this.$nextTick(() => {
          this.$bus.$emit('resultClickFj');
        });
      }

      if (item.name === '道路设计') {
        if (!item.tupuShow) {
          this.handleTupuClick(item, index, this.getDisabled(item));
        }

        this.$nextTick(() => {
          this.$bus.$emit('resultClickDl');
        });
      }

      if (item.name === '集电线路设计') {
        if (!item.tupuShow) {
          this.handleTupuClick(item, index, this.getDisabled(item));
        }

        this.$nextTick(() => {
          this.$bus.$emit('resultClickXl');
        });
      }
    },
    handleTupuClick(item, index, disabled) {
      if (item.wholeDisable) {
        return;
      }

      if (disabled) {
        if (item.tupuShow) {
          return;
        }
      }

      if (this.specificDragFlag && item.name === '机位排布') {
        return;
      }

      item.tupuShow = !item.tupuShow;

      if (item.name === '资源') {
        // 点击展示隐藏资源逻辑

        if (this.activeTupu !== -1) {
          this.$store.commit('WindFarm/SET_TUPUOBJ', {});
          this.$store.commit('WindFarm/SET_ACTIVE_TUPU_INDEX', -1);
          return;
        }

        this.$store.commit('WindFarm/SET_ACTIVE_TUPU_INDEX', 0);

        if (this.wrgInfoForm?.hasTupu) {
          this.$fetch('/windfarm/windfarm/createWrgPic', {
            showError: true,
            params: {
              elementCode: 'wspd',
              windfarmId: this.wrgInfoForm.windfarmId,
            },
          }).then((res) => {
            const { data = {} } = res;
            this.$store.commit('WindFarm/SET_TUPUOBJ', data);
          });
        }
      }

      if (item.name === '机位排布') {
        const arr = [...this.exclusiveList];
        arr.forEach(i => {
          i.isShow = item.tupuShow;
        });
        const another = [...this.turbineList];

        another.forEach(i => {
          i.isShow = item.tupuShow;
        });

        this.$store.commit('WindFarm/SET_EXCLUSIVELIST', arr);
        this.$store.commit('WindFarm/UPDATE_LIMIT_AREA');
        this.$store.commit('WindFarm/SET_TURLIST', another);
        this.$store.commit('WindFarm/UPDATE_TUILIST');
      }
      if (item.name === '测风塔选址') {
        const arr = [...this.towerList];

        arr.forEach(i => {
          i.isShow = item.tupuShow;
        });

        this.$store.commit('WindFarm/SET_TOWERLIST', arr);
        this.$store.commit('WindFarm/UPDATE_TOWER_AREA');
      }
      if (item.name === '升压站设计') {
        const otherArr = [...this.boosterList];
        otherArr.forEach(i => {
          i.isShow = item.tupuShow;
        });
        this.$store.commit('WindFarm/SET_BOOSTERLIST', otherArr);
        this.$store.commit('WindFarm/UPDATE_BOOST_AREA', otherArr);
      }

      if (item.name === '道路设计') {
        const arr = [...this.windfarmRoadList];
        arr.forEach(i => {
          i.isShow = item.tupuShow;
        });

        const otherArr = [...this.keyPointsList];
        otherArr.forEach(i => {
          i.isShow = item.tupuShow;
        });

        sessionStorage.setItem(
          'CURRENT_ROAD_STATUS',
          item.tupuShow ? '1' : '0'
        );

        const another = [...this.entrancePointList];

        another.forEach(i => {
          i.isShow = item.tupuShow;
        });

        this.$store.commit('WindFarm/SET_ROADLIST', arr);
        this.$store.commit('WindFarm/UPDATE_ROAD_LIST');
        this.$store.commit('WindFarm/SET_KEYPOINTS', otherArr);
        this.$store.commit('WindFarm/UPDATE_KEY_POINTS');
        this.$store.commit('WindFarm/SET_ENTRANCELISTS', another);
        this.$store.commit('WindFarm/UPDATE_EXCLUSIVE_LIST');
      }

      if (item.name === '集电线路设计') {
        const arr = [...this.windfarmWireList];

        arr.forEach(i => {
          i.isShow = item.tupuShow;
        });

        sessionStorage.setItem(
          'CURRENT_LINE_STATUS',
          item.tupuShow ? '1' : '0'
        );

        this.$store.commit('WindFarm/SET_WIRE_LIST', arr);
        this.$store.commit('WindFarm/UPDATE_WIRE_LIST');
      }

      //console.log(item, index);
    },
    getIconShow(isSHow) {
      //机位排布
      if (this.dataList[1].tupuShow) {
        const arr = [...this.exclusiveList];
        arr.forEach(i => {
          i.isShow = isSHow;
        });
        const another = [...this.turbineList];

        another.forEach(i => {
          i.isShow = isSHow;
        });

        this.$store.commit('WindFarm/SET_EXCLUSIVELIST', arr);
        this.$store.commit('WindFarm/UPDATE_LIMIT_AREA');
        this.$store.commit('WindFarm/SET_TURLIST', another);
        this.$store.commit('WindFarm/UPDATE_TUILIST');
      }
      if (this.dataList[2].tupuShow) {
        //测风塔选址
        const towerArr = [...this.towerList];

        towerArr.forEach(i => {
          i.isShow = isSHow;
        });

        this.$store.commit('WindFarm/SET_TOWERLIST', towerArr);
        this.$store.commit('WindFarm/UPDATE_TOWER_AREA');
      }
      if (this.dataList[4].tupuShow) {
        //升压站设计
        const otherArr = [...this.boosterList];
        otherArr.forEach(i => {
          i.isShow = isSHow;
        });
        this.$store.commit('WindFarm/SET_BOOSTERLIST', otherArr);
        this.$store.commit('WindFarm/UPDATE_BOOST_AREA', otherArr);
      }
      if (this.dataList[5].tupuShow) {
        //道路设计
        const windfarmRoadArr = [...this.windfarmRoadList];
        windfarmRoadArr.forEach(i => {
          i.isShow = isSHow;
        });

        const keyPointsArr = [...this.keyPointsList];
        keyPointsArr.forEach(i => {
          i.isShow = isSHow;
        });

        const entrancePointArr = [...this.entrancePointList];

        entrancePointArr.forEach(i => {
          i.isShow = isSHow;
        });

        this.$store.commit('WindFarm/SET_ROADLIST', windfarmRoadArr);
        this.$store.commit('WindFarm/UPDATE_ROAD_LIST');
        this.$store.commit('WindFarm/SET_KEYPOINTS', keyPointsArr);
        this.$store.commit('WindFarm/UPDATE_KEY_POINTS');
        this.$store.commit('WindFarm/SET_ENTRANCELISTS', entrancePointArr);
        this.$store.commit('WindFarm/UPDATE_EXCLUSIVE_LIST');
      }
      if (this.dataList[6].tupuShow) {
        // 机电线路设计
        const windfarmWireArr = [...this.windfarmWireList];

        windfarmWireArr.forEach(i => {
          i.isShow = isSHow;
        });
        this.$store.commit('WindFarm/SET_WIRE_LIST', windfarmWireArr);
        this.$store.commit('WindFarm/UPDATE_WIRE_LIST');
      }

      if (this.$route.name === 'power') {
        //机位排布
        const powerTurbineArr = [...this.powerTurbineList];
        powerTurbineArr.forEach(i => {
          i.isShow = isSHow;
        });

        this.$store.commit('WindFarm/SET_POWERTURLIST', powerTurbineArr);
        this.$store.commit('WindFarm/UPDATE_POWERLIST');
      }
    },
    getCluster(show) {
      var another = [];
      if (show) {
        if (this.$route.name === 'power') {
          another = [...this.powerTurbineList];
        } else {
          another = [...this.turbineList];
        }
        another.forEach(i => {
          (i.type = 'fengji'),
            (i.lng = i.lon),
            (i.isShow = show),
            (i.turbineInfo = i);
        });
        const towerArr = [...this.towerList];

        towerArr.forEach(i => {
          (i.type = 'tower'), (i.isShow = show), (i.lng = i.lon);
        });

        this.$bus.$emit('generateCluster', another);
        this.$bus.$emit('generateTowerCluster', towerArr);
      } else {
        this.$bus.$emit('generateCluster', []);
        this.$bus.$emit('generateTowerCluster', []);
      }
    },

    handleIconClick(e, item) {
      const _target = e.target;
      if (!['deploy', 'tower'].includes(item.routerName)) return;
      if (_target.classList.contains('active')) {
        _target.classList.remove('active');
        _target.classList.add('disabled');
        if (item.routerName === 'tower') {
          this.$store.commit('WindFarm/SET_RAW_MARKERS', {
            type: 'tower',
            data: [],
          });
          this.$bus.$emit('clearTowersCircle');
        } else {
          this.$store.commit('WindFarm/SET_RAW_MARKERS', {
            type: 'turList',
            data: [],
          });
        }
      } else {
        _target.classList.remove('disabled');
        _target.classList.add('active');
        if (item.routerName === 'deploy') {
          this.$bus.$emit('updateTurList');
        } else {
          this.$bus.$emit('updateTowerList');
          this.$bus.$emit('getTowersCircle');
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.farm-item-box {
  position: absolute;
  z-index: 400;
  //right: 45px;
  left: 425px;
  top: 55px;
  display: flex;
  .item {
    //user-select: none;
    display: flex;
    align-items: center;
    height: 35px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    padding: 10px 12px;
    margin-right: 5px;
    border-radius: 4px;
    justify-content: space-between;
    cursor: pointer;
    background: #20405d;
    border: solid 2px #89c6ff;
    color: #a3d3ff;
    &.is-use{
      background: #767676;
    }
    &.is-disabled {
      color: #8c8c8c;
      cursor: not-allowed;

      .button,
      .result-show {
        color: #8c8c8c;
        cursor: not-allowed;

        &.is-disabled {
          color: #8c8c8c;
          cursor: not-allowed;
        }
      }
    }
    &.is-active {
      color: #fff;
      background-color: rgba(24, 144, 255, 1);

      font-family: 'Source Han Sans CN';
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 22px;
      .button,
      .result-show {
        color: #fff;
      }
    }

    .button,
    .result-show {
      cursor: pointer;
      color: #0876bd;

      &.is-disabled {
        color: #999;
        cursor: not-allowed;
      }

      i {
        font-size: 16px;
        &.is-active {
          color: #547efc;
        }
        &.is-not-active {
          color: #999;
        }
      }
    }
  }
}
.active {
  color: #67c23a;
}
.disabled {
  color: #c0c4cc;
}
</style>
